import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, IS_CUSTOM_AUTH } from "auth/useAuth";
import config from "../../config/env";

const Logout = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    if (IS_CUSTOM_AUTH) {
      auth.signOut();
      navigate("/login", { replace: true, state: { flash: "Você saiu da sua conta." } });
      return;
    }
    // Hosted UI: clear local user then end the Cognito session.
    if (auth.isAuthenticated) {
      auth.removeUser();
      window.location.href = `${config.COGNITO_DOMAIN}/logout?client_id=${config.COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(config.APP_URL)}`;
    }
  }, []);

  return <></>;
};

export default Logout;
